import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  handleKeyPress(event) {
    if (event.key === 'Enter' || event.key === ' ') {
      event.preventDefault();
      const label = event.currentTarget;
      const radio = document.getElementById(label.getAttribute('for'));
      
      if (radio && !radio.disabled) {
        radio.checked = true;
        radio.dispatchEvent(new Event('change', { bubbles: true }));
      }
    }
  }
} 